module.exports = __webpack_public_path__ + "static/media/support7.15671687.png";